const S3_BASE_URL = "https://d1g9iww9o5ioh1.cloudfront.net/gallery_page";

// Helper function to generate image objects for afrostalgia-style galleries
const generateImageObjects = (galleryName, count, prefix) => {
  return Array.from({ length: count }, (_, i) => ({
    id: i + 1,
    image: `${S3_BASE_URL}/${galleryName}/${prefix}${i + 1}.webp`,
  }));
};

// Generate image objects for each gallery
export const afrostalgiaimgs = generateImageObjects("afrostalgia", 100, "pic");

export const afrostalgia2imgs = generateImageObjects(
  "afrostalgia2",
  109,
  "afrostalgia"
);

export const afrosoundsimgs = [
  "9O7A8722.webp",
  "9O7A8704.webp",
  "9O7A8706.webp",
  "9O7A8756.webp",
  "9O7A8846.webp",
  "9O7A8867.webp",
  "9O7A8879.webp",
  "9O7A8910.webp",
  "9O7A8815.webp",
  "9O7A8932.webp",
  "9O7A8940.webp",
  "9O7A8942.webp",
  "9O7A8948.webp",
  "9O7A8950.webp",
  "9O7A8911.webp",
  "9O7A8707.webp",
  "9O7A8830.webp",
  "9O7A8855.webp",
  "9O7A8924.webp",
  "9O7A8889.webp",
  "9O7A8898.webp",
  "9O7A8899.webp",
  "9O7A8701.webp",
  "9O7A8957.webp",
  "9O7A8699.webp",
].map((image, index) => ({
  id: index + 1,
  image: `${S3_BASE_URL}/afrosounds/${image}`,
}));

export const taceimgs = [
  [
    `${S3_BASE_URL}/tace/tace1.webp`,
    `${S3_BASE_URL}/tace/tace2.webp`,
    `${S3_BASE_URL}/tace/tace3.webp`,
    `${S3_BASE_URL}/tace/tace4.webp`,
    `${S3_BASE_URL}/tace/tace5.webp`,
  ],
  [`${S3_BASE_URL}/tace/tace6.webp`, `${S3_BASE_URL}/tace/tace7.webp`],
  [
    `${S3_BASE_URL}/tace/tace11.webp`,
    `${S3_BASE_URL}/tace/tace12.webp`,
    `${S3_BASE_URL}/tace/tace13.webp`,
    `${S3_BASE_URL}/tace/tace14.webp`,
    `${S3_BASE_URL}/tace/tace15.webp`,
    `${S3_BASE_URL}/tace/tace16.webp`,
  ],
  [
    `${S3_BASE_URL}/tace/tace8.webp`,
    `${S3_BASE_URL}/tace/tace9.webp`,
    `${S3_BASE_URL}/tace/tace10.webp`,
  ],
];

export const taceimgst = [
  [
    `${S3_BASE_URL}/tace/tace1.webp`,
    `${S3_BASE_URL}/tace/tace2.webp`,
    `${S3_BASE_URL}/tace/tace3.webp`,
    `${S3_BASE_URL}/tace/tace4.webp`,
  ],
  [
    `${S3_BASE_URL}/tace/tace5.webp`,
    `${S3_BASE_URL}/tace/tace6.webp`,
    `${S3_BASE_URL}/tace/tace7.webp`,
  ],
  [
    `${S3_BASE_URL}/tace/tace8.webp`,
    `${S3_BASE_URL}/tace/tace9.webp`,
    `${S3_BASE_URL}/tace/tace10.webp`,
  ],
  [
    `${S3_BASE_URL}/tace/tace11.webp`,
    `${S3_BASE_URL}/tace/tace12.webp`,
    `${S3_BASE_URL}/tace/tace13.webp`,
  ],
  [
    `${S3_BASE_URL}/tace/tace14.webp`,
    `${S3_BASE_URL}/tace/tace15.webp`,
    `${S3_BASE_URL}/tace/tace16.webp`,
  ],
];

export const introsummerimgs = [
  "IMG_9599.webp",
  "IMG_9600.webp",
  "IMG_9601.webp",
  "IMG_9602.webp",
  "IMG_9603.webp",
  "IMG_9606.webp",
  "IMG_9607.webp",
  "IMG_9608.webp",
  "IMG_9609.webp",
  "IMG_9610.webp",
  "IMG_9611.webp",
  "IMG_9612.webp",
  "IMG_9613.webp",
  "IMG_9614.webp",
  "IMG_9615.webp",
  "IMG_9616.webp",
  "IMG_9617.webp",
  "IMG_9618.webp",
  "IMG_9619.webp",
  "IMG_9620.webp",
  "IMG_9621.webp",
  "IMG_9622.webp",
  "IMG_9623.webp",
  "IMG_9624.webp",
  "IMG_9625.webp",
  "IMG_9626.webp",
  "IMG_9627.webp",
  "IMG_9628.webp",
  "IMG_9629.webp",
  "IMG_9630.webp",
  "IMG_9631.webp",
  "IMG_9632.webp",
  "IMG_9633.webp",
  "IMG_9634.webp",
  "IMG_9635.webp",
  "IMG_9636.webp",
  "IMG_9637.webp",
  "IMG_9638.webp",
  "IMG_9639.webp",
  "IMG_9640.webp",
  "IMG_9641.webp",
  "IMG_9642.webp",
  "IMG_9643.webp",
  "IMG_9644.webp",
  "IMG_9645.webp",
  "IMG_9646.webp",
  "IMG_9647.webp",
  "IMG_9648.webp",
  "IMG_9649.webp",
  "IMG_9650.webp",
  "IMG_9651.webp",
  "IMG_9652.webp",
  "IMG_9653.webp",
  "IMG_9654.webp",
  "IMG_9655.webp",
  "IMG_9656.webp",
  "IMG_9657.webp",
  "IMG_9658.webp",
  "IMG_9659.webp",
  "IMG_9660.webp",
  "IMG_9661.webp",
  "IMG_9662.webp",
  "IMG_9663.webp",
  "IMG_9664.webp",
  "IMG_9665.webp",
  "IMG_9666.webp",
  "IMG_9667.webp",
  "IMG_9668.webp",
  "IMG_9669.webp",
  "IMG_9670.webp",
  "IMG_9671.webp",
  "IMG_9672.webp",
  "IMG_9673.webp",
  "IMG_9674.webp",
  "IMG_9675.webp",
  "IMG_9676.webp",
  "IMG_9677.webp",
  "IMG_9678.webp",
  "IMG_9679.webp",
  "IMG_9680.webp",
  "IMG_9681.webp",
  "IMG_9682.webp",
  "IMG_9683.webp",
  "IMG_9684.webp",
  "IMG_9685.webp",
  "IMG_9686.webp",
  "IMG_9687.webp",
  "IMG_9688.webp",
  "IMG_9689.webp",
  "IMG_9690.webp"
].map((image, index) => ({
  id: index + 1,
  image: `${S3_BASE_URL}/introducingsummer/${image}`,
}));


export const offseasonimgs = [
  "IMG_0733.webp",
  "IMG_0734.webp",
  "IMG_0760.webp",
  "IMG_0755.webp",
  "IMG_0737.webp",
  "IMG_0738.webp",
  "IMG_0739.webp",
  "IMG_0740.webp",
  "IMG_0741.webp",
  "IMG_0742.webp",
  "IMG_0743.webp",
  "IMG_0744.webp",
  "IMG_0745.webp",
  "IMG_0746.webp",
  "IMG_0747.webp",
  "IMG_0748.webp",
  "IMG_0749.webp",
  "IMG_0750.webp",
  "IMG_0751.webp",
  "IMG_0752.webp",
  "IMG_0753.webp",
  "IMG_0754.webp",
  "IMG_0756.webp",
  "IMG_0757.webp",
  "IMG_0758.webp",
  "IMG_0759.webp",
  "IMG_0735.webp"
].map((image, index) => ({
  id: index + 1,
  image: `${S3_BASE_URL}/offseason/${image}`,
}));